import React from "react";
import { Grid, Paper, Box } from "@material-ui/core";

import DateSelector from "components/DateSelector";
import CountrySelector from "components/CountrySelector";

import { useTranslation } from "react-i18next";

import PeriodSelector from "components/PeriodSelector";

export default function SelectionBar({
  minDate,
  maxDate,
  country,
  onCountryChange,
  selectedDate,
  onSelectedDateChange,
  baselineDate,
  onBaselineDateChange,
  period,
  onPeriodChange,
}) {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} id="side-bar">
      <Grid item md={12} xs={12}>
        <Paper elevation={1}>
          <Box p={1} width="100%">
            <CountrySelector
              label={t("countrySelector.label")}
              country={country}
              onCountryChange={onCountryChange}
            />
          </Box>
        </Paper>
      </Grid>
      <Grid item md={12} xs={12}>
        <Paper elevation={1}>
          <Box p={1} width="100%">
            <PeriodSelector
              label={t("period.label")}
              value={period}
              onChange={onPeriodChange}
            />
          </Box>
        </Paper>
      </Grid>
      <Grid item md={12} xs={12}>
        <Paper elevation={1}>
          <Box p={1} width="100%">
            <DateSelector
              label={t("baselineDate.label")}
              date={baselineDate}
              onDateChange={onBaselineDateChange}
              minDate={minDate}
              maxDate={maxDate}
            />
          </Box>
        </Paper>
      </Grid>
      <Grid item md={12} xs={12}>
        <Paper elevation={1}>
          <Box p={1} width="100%">
            <DateSelector
              label={t("selectedDate.label")}
              date={selectedDate}
              onDateChange={onSelectedDateChange}
              minDate={minDate}
              maxDate={maxDate}
            />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
}
